import { useState } from "react"
import { Grid, Box, Stack } from "@mui/material"
import { Masonry } from "@mui/lab"
import Frame from "components/Frame"
import PageButton from "components/PageButton"
import Toggle from "components/Toggle"
import About from "components/About"
import theme from "theme"
import data from "../data/data.json"

const Gallery = () => {
  const [page, setPage] = useState(1)
  const [colorOverride, setColorOverride] = useState(true)
  const pageSize = 64
  const pageFirst = 1
  const pageLast = Math.ceil(data.length / pageSize)
  const pageData = data.sort((a,b) => a.id - b.id).slice(pageSize*(page-1), pageSize*page)
  const defaultColor = theme.palette.primary.main
  const changePage = (x: number) => {
    let nextPage = page + x
    if (nextPage < 1) {
      nextPage = 1
    }
    setPage(nextPage)
    if (x > 0) {
      window.scrollTo({top: 0,behavior: "smooth"})
    }
  }
  return (
    <Box>
      <Box margin={2}></Box>
      <Stack direction="row" spacing={0} justifyContent="space-between" padding={"0em 0.3em 3em 0em"}>
        <Box padding={"1em 0em 0em 1em"}>
          <Stack direction="row" spacing={1} sx={{ alignItems: "center", verticalAlign: "center" }}>
            <About/>
            {(colorOverride && <Toggle onClick={() => setColorOverride(false)} defaultChecked inputProps={{"aria-label": "ant design"}}/>)}
            {(!colorOverride && <Toggle onClick={() => setColorOverride(true)} inputProps={{"aria-label": "ant design"}}/>)}
          </Stack>
        </Box>
        <Stack direction="row" justifyContent={"flex-end"}>
          <Box padding={"0.75em 0em 0em 0em"}>
            {(page > pageFirst && <PageButton label={"back"} callback={changePage} direction={-1}/>)}
            {(page <= pageFirst && <Box paddingTop={3.1}></Box>)}
          </Box>
        </Stack>
      </Stack>
      <Grid container direction="column">
        <Masonry columns={{ xs: 1, sm: 2, md: 4 }} spacing={0}>
          {pageData.map((e, index) => {
              let metadata = JSON.parse(JSON.stringify(e))
              if (colorOverride) {
                metadata.settings.color1 = defaultColor
                metadata.settings.color2 = defaultColor
                metadata.settings.color3 = defaultColor
                metadata.settings.color4 = defaultColor
              }
              return(
                <Frame key={index} metadata={metadata}/>
              )
            })
          }
        </Masonry>
      </Grid>
      <Stack direction="row" spacing={0} justifyContent="space-between" padding={"0em 0.3em 3em 0em"}>
        <Box></Box>
        <Stack direction="row" justifyContent={"flex-end"}>
          <Box paddingRight={1}>
            {(page < pageLast && <PageButton label={"next"} callback={changePage} direction={1}/>)}
          </Box>
        </Stack>
      </Stack>
    </Box>
  )
}

export default Gallery
